module.exports = __webpack_public_path__ + "static/media/addIndividual.d84880a7.svg";